"use strict";

angular.module('rmPresenter', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');